<template>
  <BModal
    v-model="visible"
    :title="title"
    centered
    :content-class="height ? 'modal-dynamic-height' : ''"

    :ok-title="isReadOnly ? 'Zatvori' : okText"
    :cancel-title="cancelText"
    :ok-variant="okColor"
    cancel-variant="secondary"
    :ok-only="isReadOnly"
    
    @ok="handleOk"
    @hidden="$emit('update:modelValue', false)"
    :modal-class="['custom-modal', modalClass]"
    header-class="custom-modal-header"
    :no-footer="hideFooter"
  >

    <!-- HEADER -->
    <template #header="{ close }">

    <div class="custom-modal-header d-flex justify-content-between align-items-center w-100">

      <div class="modal-title">
        {{ title }}
      </div>

      <div class="d-flex align-items-center gap-0">

        <!-- dodatna dugmad -->
        <slot name="header-actions"></slot>

        <!-- close dugme -->
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          @click="close()"
        ></button>

      </div>

    </div>

    </template>


    <!-- BODY -->
    <slot />

    <!-- FOOTER override (ako postoji) -->
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </BModal>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    modelValue: Boolean,
    title: String,
    okText: {
      type: String,
      default: 'OK'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    okColor: {
      type: String,
      default: 'primary'
    },
     hideFooter: {      
    type: Boolean,
    default: false
  },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: null
    },
    modalClass: {
      type: String,
      default: ""
    }
  },
  emits: ['update:modelValue', 'confirm'],
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  methods: {
    handleOk() {
      if (!this.isReadOnly) {
        this.$emit('confirm')
      }
    }
  }
}
</script>

<style>
body.modal-open {
  padding-right: 0 !important;
}

.custom-modal-header {
  background: linear-gradient(to right, #1357A2, #1e4f9e);
  color: white !important;
  border-bottom: none !important;
  height: 50px;
}

.custom-modal-header .modal-title {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Close (X) dugme */
.custom-modal-header .btn-close {
  filter: invert(1);
  opacity: 0.9;
  font-size: 10px !important;
}

.custom-modal-header .btn-close:hover {
  opacity: 1;
}

/* Footer linija ukloni ako želiš čist izgled */
.custom-modal .modal-footer {
  border-top: 1px solid #eef1f5;
}


.modal-dynamic-height {
  height: 90vh;
}

.modal-dynamic-height .modal-body {
  height: calc(90vh - 120px);
  overflow: hidden;
}
</style>